var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetween(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140.000000, -6999.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,6839 C102.448,6839 102,6839.448 102,6840 L102,6845 L97.863,6845 C97.418,6845 97.195,6844.461 97.51,6844.146 L99.193,6842.464 C99.583,6842.073 99.583,6841.44 99.193,6841.05 C98.802,6840.659 98.169,6840.659 97.779,6841.05 L94.242,6844.587 C93.461,6845.367 93.461,6846.633 94.242,6847.413 C94.808,6847.979 94.927,6848.099 97.778,6850.95 C98.169,6851.34 98.802,6851.34 99.193,6850.949 C99.583,6850.559 99.583,6849.926 99.193,6849.535 L97.512,6847.853 C97.197,6847.538 97.42,6847 97.865,6847 L102,6847 L102,6858 C102,6858.552 102.448,6859 103,6859 C103.552,6859 104,6858.552 104,6858 L104,6840 C104,6839.448 103.552,6839 103,6839 M90.222,6847.05 C89.831,6846.66 89.198,6846.66 88.807,6847.05 C88.417,6847.441 88.417,6848.074 88.807,6848.465 L90.488,6850.146 C90.803,6850.461 90.58,6851 90.135,6851 L86,6851 L86,6840 C86,6839.448 85.552,6839 85,6839 C84.448,6839 84,6839.448 84,6840 L84,6858 C84,6858.552 84.448,6859 85,6859 C85.552,6859 86,6858.552 86,6858 L86,6853 L90.137,6853 C90.582,6853 90.805,6853.539 90.49,6853.853 L88.807,6855.536 C88.417,6855.926 88.417,6856.56 88.807,6856.95 C89.198,6857.34 89.831,6857.34 90.221,6856.95 L93.758,6853.413 C94.539,6852.632 94.539,6851.367 93.758,6850.587 C93.385,6850.213 94.215,6851.043 90.222,6847.05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetween);
export default __webpack_public_path__ + "static/media/between.ae5fefc41c604850bae6b4c372cb6f27.svg";
export { ForwardRef as ReactComponent };